
import ThemeSelector from '@/components/ThemeSelector.vue';
import LangSwitcher from '@/components/Layout/LangSwitcher';
import setting from '@/components/settings/setting';

export default {
  components: {
    ThemeSelector,
    LangSwitcher,
    setting,
  },
  head() {
    return {
      link: [],
    };
  },
  computed: {
    dbRemote: {
      get() {
        return this.$warehouse.get('dbRemote') || this.$config.DB_REMOTE;
      },
      set(value) {
        this.$warehouse.set('dbRemote', value);
      },
    },
    dbUsername: {
      get() {
        return this.$warehouse.get('dbUsername') || this.$config.DB_USERNAME;
      },
      set(value) {
        this.$warehouse.set('dbUsername', value);
      },
    },
    dbPassword: {
      get() {
        return this.$warehouse.get('dbPassword') || this.$config.DB_PASSWORD;
      },
      set(value) {
        this.$warehouse.set('dbPassword', value);
      },
    },
  },
};
